import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { RewardUnlockStrategy } from '@brandclub/types';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { styled, useTheme } from '@mui/material';
import React from 'react';
import '../../BrandclubLanding/components/BrandclubBreadcrumbs/BrandclubBreadcrumbs.js';
import '../../BrandclubLanding/components/BrandclubProductCard/index.js';
import '../../BrandclubLanding/components/PopupDrawer/PopupDrawer.js';
import '../../BrandclubLanding/components/ProductPageDialog/ArrowLink.js';
import '../../BrandclubLanding/components/BrandclubPhoneInput/index.js';
import '../../BrandclubLanding/components/ProductPageDialog/RewardTable.js';
import '../../BrandclubLanding/components/BrandclubVideo.js';
import '../../BrandclubLanding/components/ProductPageDialog/SharePage.js';
import '../../analytics/events.js';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../BrandclubLanding/components/ProductPageDialog/ProductPageDialogContent.js';
import { CampaignType } from '../../types/Campaign.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { getRetailerFromId, formatMoney } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import { getBuyOrViewProductMetaTag } from '../../utils/dataLayer.js';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import { getSortedBuyBoxProducts, getPurchaseRewardAmountForProduct, isProductOutOfStock, isProductEligibleForCheckout, getAddToBagText } from '../../utils/productUtils.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../../BrandclubLanding/components/RetailerIconGroup/index.js';
import { RewardPillWithText } from '../../BrandclubLanding/components/RewardPill/RewardPillWithText.js';
import { OutOfStockPill } from '../../BrandclubLanding/components/OutOfStockPill/OutOfStockPill.js';
import { brandclubStyles } from '../../styles/index.js';
import { AppButton } from '../AppButton/index.js';

var ContentContainer = styled('div', {
    label: 'PriceDialogContentContainer',
})(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ({
        maxWidth: 625,
        width: '100%',
        color: theme.palette.primary.main,
        '.bc_header': {
            display: 'flex',
            alertItems: 'center',
            justifyContent: 'center',
            padding: '36px 0 20px 0',
            position: 'relative',
            '.bc_title': {
                fontSize: 24,
                fontWeight: 600,
                color: 'inherit',
            },
            '.bc_close': {
                position: 'absolute',
                right: 20,
                top: 20,
            },
        },
        '.product_price': __assign(__assign({ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', paddingBottom: 20, maxHeight: 585, overflow: 'auto' }, brandclubStyles.customScrollbar), { '.price_card': {
                color: 'inherit',
                cursor: 'default',
                border: "1px solid #ebeef2",
                padding: '18px 20px',
                margin: '0 20px',
                width: '100%',
                maxWidth: 483,
                boxSizing: 'border-box',
                borderRadius: 6,
                display: 'flex',
                '.retailer_icon': {
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '20px',
                    marginTop: '5px',
                    img: {
                        maxWidth: '100%',
                        maxHeight: '100%',
                    },
                    '.external_link': {
                        '&:not([href])': {
                            all: 'unset',
                        },
                    },
                },
                '.retailer_price': {
                    flex: 1,
                    div: {
                        width: 'fit-content',
                    },
                    '.name': {
                        fontSize: 14,
                        fontWeight: 600,
                    },
                    '.price': (_b = {
                            fontSize: 24,
                            fontWeight: 600,
                            color: "inherit !important"
                        },
                        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                            fontSize: 22,
                        },
                        _b),
                },
            } }),
        '.actions': (_c = {
                display: 'flex',
                gap: 20,
                justifyContent: 'flex-end'
            },
            _c["@media (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                flexDirection: 'column',
                gap: 10,
                alignItems: 'center',
            },
            _c),
    });
});
var PriceDialogContent = function (_a) {
    var productsToList = _a.productsToList, onBuyClick = _a.onBuyClick, onClose = _a.onClose, onOpenRetailerProductPageClick = _a.onOpenRetailerProductPageClick, customBagButtonStyle = _a.customBagButtonStyle, checkoutAllowedOfferType = _a.checkoutAllowedOfferType, className = _a.className;
    var theme = useTheme();
    var sortedProductListed = getSortedBuyBoxProducts(productsToList);
    return (React.createElement(ContentContainer, { className: className },
        React.createElement("div", { className: "bc_header" },
            React.createElement("div", { className: "bc_title" }, "Choose a retailer"),
            React.createElement("div", { className: "bc_close" },
                React.createElement(CloseRoundedIcon, { onClick: onClose, sx: { fontSize: 30, color: 'inherit', cursor: 'pointer' } }))),
        React.createElement("div", { className: "product_price" }, sortedProductListed.map(function (item, idx) {
            var _a;
            var _b, _c;
            var hasActiveInstantReward = false;
            for (var _i = 0, _d = (_b = item === null || item === void 0 ? void 0 : item.campaignRewards) !== null && _b !== void 0 ? _b : []; _i < _d.length; _i++) {
                var campaignReward = _d[_i];
                if ((campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.campaignType) === CampaignType.DailyDealsRewardCampaign ||
                    (campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.rewardUnlockStrategy) === RewardUnlockStrategy.Instant) {
                    hasActiveInstantReward = true;
                    break;
                }
            }
            var rewardAmount = getPurchaseRewardAmountForProduct(item);
            var rewardPercent = !!item.retailPrice && !!rewardAmount ? (rewardAmount * 100) / item.retailPrice : 0;
            var isOutOfStock = isProductOutOfStock(item, checkoutAllowedOfferType);
            return (React.createElement("div", { key: idx, className: "price_card" },
                React.createElement("div", { className: "retailer_icon" },
                    React.createElement("img", { loading: "lazy", alt: "retailer", src: getEntityImage(item.retailerId, 'retailer') })),
                React.createElement("div", { style: { flex: 1 } },
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                        React.createElement("div", { className: "retailer_price" },
                            React.createElement("a", { href: item.retailerProductPageUrl, target: "_blank", onClick: function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onOpenRetailerProductPageClick(item);
                                }, style: {
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    display: 'block',
                                    width: 'fit-content',
                                }, className: "external_link bc" },
                                React.createElement("div", { className: "name" }, getRetailerFromId(item.retailerId) || '')),
                            React.createElement("div", { className: "price" }, formatMoney(item.retailPrice))),
                        React.createElement(AppButton, __assign({ invertStyle: true, style: {
                                borderRadius: (_c = theme === null || theme === void 0 ? void 0 : theme.globalButtonRadius) !== null && _c !== void 0 ? _c : 999,
                            }, sx: (_a = {
                                    fontFamily: 'inherit',
                                    backgroundColor: "".concat((customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.bgColor) || '#f6f8fa', " !important"),
                                    color: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.textColor) || theme.palette.primary.main,
                                    border: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.borderEnabled)
                                        ? "1px solid ".concat(customBagButtonStyle.borderColor)
                                        : 'none',
                                    width: 82,
                                    height: 35,
                                    fontSize: 14,
                                    paddingLeft: '16px',
                                    paddingRight: '16px',
                                    fontWeight: 600,
                                    margin: '10px 0',
                                    '&:hover': {
                                        backgroundColor: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.bgColor) || '#f6f8fa',
                                    }
                                },
                                _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                                    fontSize: 14,
                                    height: 32,
                                },
                                _a["@media screen and (max-width: 400px)"] = {
                                    maxWidth: 200,
                                },
                                _a) }, getBuyOrViewProductMetaTag(isProductEligibleForCheckout(item, checkoutAllowedOfferType) ? 'buy' : 'view', getRetailerFromId(item.retailerId) || '', item.name, item.id, item.stacklineSku, window.location.href, item.retailPrice), { onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if (isProductEligibleForCheckout(item, checkoutAllowedOfferType)) {
                                    onBuyClick(item);
                                    onClose();
                                }
                                else {
                                    onOpenRetailerProductPageClick(item);
                                }
                            } }), getAddToBagText(item, checkoutAllowedOfferType))),
                    isOutOfStock ? React.createElement(OutOfStockPill, { pillContainerStyle: {} }) : null,
                    rewardAmount && !isOutOfStock ? (React.createElement(RewardPillWithText, { pillContainerStyle: {}, rewardAmount: rewardAmount, rewardPercent: rewardPercent, rewardCampaignType: hasActiveInstantReward
                            ? CampaignType.DailyDealsRewardCampaign
                            : CampaignType.PurchaseRewardCampaign })) : null)));
        })),
        React.createElement("div", { className: "actions" })));
};

export { PriceDialogContent };
//# sourceMappingURL=PriceDialogContent.js.map
